
import { find } from 'lodash';
import { mapGetters } from 'vuex';
import ActivitiesList from './ActivitiesList.vue';
import AdsApi from '../../libs/ads-request/ads-api';

export default {
  name: 'InventoryMobile',
  components: {
    ActivitiesList,
  },
  props: {
    greenList: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showView: false,
    activitySelected: null,
    loaderMessage: 'Cargando inventario ...',
    loaderError: false,
  }),
  computed: {
    ...mapGetters('Activity', {
      parentSuperorderGreenChecklistActivities: 'parentSuperorderGreenChecklistActivities',
    }),

    isThemeDefault() {
      return this.$session.get('brand') === '';
    },
    isThemeAudi() {
      return this.$session.get('brand') === 'audi';
    },
    mobile() {
      return this.$q.screen.lt.sm;
    },
    desktop() {
      return this.$q.screen.gt.md;
    },
    tablet() {
      return this.$q.screen.lt.lg && this.$q.screen.gt.sm;
    },

    greenActivities() {
      return [...this.greenList, ...this.parentSuperorderGreenChecklistActivities];
    },
  },
  watch: {
    reset() {
      this.activitySelected = null;
    },
  },
  mounted() {
    this.loadInventory();
  },
  methods: {
    loadInventory() {
      this.loaderError = false;
      return AdsApi.getUnbudgetedActivities()
        .then((orders) => {
          this.showView = true;
          orders.forEach((order) => {
            this.orderRemap(order);
          });
        })
        .catch(() => {
          this.loaderError = true;
        });
    },
    orderRemap(order) {
      order.activityClient.forEach((activity) => {
        const principalActivityCloned = activity;
        principalActivityCloned.show = false;
        if (
          principalActivityCloned.activity_status_id === 2
          && principalActivityCloned.inventario === 1
        ) {
          const object = find(
            this.greenList,
            (a) => a.order_activity_id === principalActivityCloned.order_activity_id,
          );
          if (object == null) this.greenList.push(principalActivityCloned);
        }
      });
    },
    redirectToReport(activity) {
      this.$router.push({
        name: 'report',
        params: {
          id: activity.order_activity_id,
          activity,
          origen: 'inventario',
        },
      });
    },
  },
};
